import {
  getStoreId,
  storeInformationQueries,
} from "$/hooks/use-store-information"
import serviceEventQueries from "$/lib/queries/service-event-queries"
import storeQueries from "$/lib/queries/store-queries"
import { STORE_TYPE } from "@repo/common"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/event")({
  loader: async ({ context: { queryClient } }) => {
    // Redirect physical stores to calendar page
    const storeInfo = await queryClient.ensureQueryData(
      storeInformationQueries.detail(queryClient),
    )
    const currentStore = storeInfo.stores.find(
      (store) => store.id === storeInfo.storeId,
    )
    if (currentStore?.type === STORE_TYPE.PHYSICAL) {
      throw redirect({
        to: "/calendar",
        replace: true,
      })
    }

    const storeId = await getStoreId()
    if (!storeId) throw new Error("No store ID found")

    queryClient.prefetchQuery(serviceEventQueries.list({ storeId }))
    const store = await queryClient.fetchQuery(storeQueries.detail(storeId))

    return {
      crumb: `Event - ${store.name}`,
      from: "/event",
    }
  },
})
